import { Field, Switch as DSSwitch, type SwitchProps as DSSwitchProps } from "@eisox/design-system";

import { useFieldContext } from "../form.context";
import { FieldErrors } from "./field-errors.component";

interface SwitchProps extends DSSwitchProps<boolean> {
  className?: string;
}

const Switch: React.FC<SwitchProps> = ({ onCheckedChange, onBlur, className, ...props }) => {
  const field = useFieldContext<boolean>();

  return (
    <Field.Root className={className}>
      <DSSwitch
        {...props}
        checked={field.state.value}
        onCheckedChange={value => {
          field.handleChange(value ?? false);
          onCheckedChange?.(value ?? false);
        }}
        onBlur={event => {
          field.handleBlur();
          onBlur?.(event);
        }}
      />
      <FieldErrors />
    </Field.Root>
  );
};

export { Switch };
export type { SwitchProps };
